import AOS from 'aos';
import { onDomReady } from './utilities/browser.js';

AOS.init({
	delay: 100,
	once: true,
});

onDomReady(() => {
	new window.Swiper('.blog-slider', {
		spaceBetween: 30,
		effect: 'fade',
		loop: true,
		mousewheel: {
			invert: false,
		},
		// autoHeight: true,
		pagination: {
			el: '.blog-slider__pagination',
			clickable: true,
		},
	});

	new window.Swiper(".foodSlider", {
		slidesPerView: 1,
		loop: true,
		spaceBetween: 30,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		}
	});
});
